/** Ticket detail screen — timeline + photos + actions */
import React from 'react';
import { ArrowLeft, Droplets, MapPin, Clock, User, Camera, MessageSquare,
  CheckCircle2, AlertTriangle, Wrench, Sparkles, Share2, Printer, ChevronRight,
  PlayCircle, FileText } from 'lucide-react';
import { C, fontHead, overline, primaryBtn, secondaryBtn } from '../_tokens';

export default function ScreenTicketDetail() {
  return (
    <div style={{ background: C.bg, color: C.text, fontFamily: 'Inter', minHeight: '100%' }}>
      {/* HEADER */}
      <div style={{
        padding: '24px 36px', borderBottom: `1px solid ${C.border}`,
        display: 'flex', alignItems: 'center', gap: 16,
      }}>
        <button style={{ ...secondaryBtn, padding: '8px 12px' }}>
          <ArrowLeft size={14} /> Tutti i ticket
        </button>
        <div style={{ height: 24, width: 1, background: C.border }} />
        <span style={{ fontFamily: 'monospace', fontSize: 12, color: C.textSec }}>TKT-2847</span>
        <span style={{
          fontSize: 10, fontWeight: 700, letterSpacing: '0.1em',
          padding: '4px 10px', borderRadius: 5,
          background: `${C.terra}22`, color: C.terra,
        }}>URGENTE</span>
        <span style={{
          fontSize: 10, fontWeight: 600, letterSpacing: '0.08em',
          padding: '4px 10px', borderRadius: 5,
          background: `${C.cyan}22`, color: C.cyan,
        }}>IN LAVORAZIONE</span>
        <div style={{ flex: 1 }} />
        <button style={{ ...secondaryBtn, padding: '8px 10px' }}><Share2 size={13} /></button>
        <button style={{ ...secondaryBtn, padding: '8px 10px' }}><Printer size={13} /></button>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1.6fr 1fr', gap: 0, minHeight: 'calc(100vh - 75px)' }}>
        {/* LEFT: main content */}
        <div style={{ padding: '32px 36px', borderRight: `1px solid ${C.border}` }}>
          <div style={{ display: 'flex', alignItems: 'flex-start', gap: 18, marginBottom: 18 }}>
            <div style={{
              width: 52, height: 52, borderRadius: 14,
              background: `${C.terra}22`, border: `1px solid ${C.terra}44`,
              display: 'grid', placeItems: 'center', flexShrink: 0,
              boxShadow: `0 0 24px ${C.terra}33`,
            }}><Droplets size={22} color={C.terra} /></div>
            <div style={{ flex: 1 }}>
              <h1 style={{ fontFamily: fontHead, fontSize: 28, fontWeight: 600, margin: 0,
                           letterSpacing: '-0.02em', lineHeight: 1.2 }}>
                Perdita continua scarico lavabo, allagamento parziale
              </h1>
              <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginTop: 12, fontSize: 13, color: C.textSec, flexWrap: 'wrap' }}>
                <Meta icon={MapPin} text="Hotel Galleria · Camera 208" />
                <Meta icon={Clock} text="Aperto 2 minuti fa" />
                <Meta icon={User} text="Da Front Office · Marco R." />
                <span style={{
                  fontSize: 10, color: C.terra, fontWeight: 700,
                  padding: '3px 8px', background: `${C.terra}22`, borderRadius: 5,
                }}>SLA SCADUTO -3 MIN</span>
              </div>
            </div>
          </div>

          {/* Storico camera (no AI, è solo conteggio reale) */}
          <div style={{
            padding: 16, borderRadius: 14, background: 'rgba(255,255,255,0.025)',
            border: `1px solid ${C.border}`, marginBottom: 28,
            display: 'flex', alignItems: 'flex-start', gap: 12,
          }}>
            <div style={{ flex: 1 }}>
              <div style={{ ...overline, marginBottom: 6 }}>Storico Camera 208 · 90 giorni</div>
              <div style={{ fontSize: 13.5, color: C.text, lineHeight: 1.5 }}>
                <b style={{ color: C.terra }}>3 ticket idraulici aperti</b> negli ultimi 28 giorni · 1 elettrico ·
                ultimo intervento idraulico chiuso il 15 Maggio (sostituzione guarnizione lavabo).
                <button style={{ background: 'transparent', border: 'none', color: C.gold,
                                cursor: 'pointer', fontSize: 12, fontWeight: 600, marginLeft: 4 }}>
                  Vedi storico camera →
                </button>
              </div>
            </div>
          </div>

          {/* Description */}
          <div style={{ marginBottom: 32 }}>
            <div style={{ ...overline, marginBottom: 10 }}>Descrizione operatore</div>
            <p style={{ fontSize: 14, lineHeight: 1.65, color: C.text, margin: 0 }}>
              Perdita continua dal punto di attacco del sifone sotto il lavabo del bagno principale.
              <b> Verificato in loco alle 09:38</b>: l&apos;acqua gocciola con cadenza di circa 1 goccia ogni 3 secondi,
              ristagno visibile dentro il mobile sottostante. Tappeto del bagno bagnato.
              Camera attualmente vuota (ospite in colazione). Ho chiuso il rubinetto di mandata sotto al lavabo.
            </p>
          </div>

          {/* Photos */}
          <div style={{ marginBottom: 32 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
              <div style={{ ...overline }}>Foto allegate · 2</div>
              <button style={{ background: 'transparent', border: 'none', color: C.gold, fontSize: 12,
                              cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: 4 }}>
                <Camera size={12} /> Aggiungi
              </button>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 10 }}>
              <PhotoTile label="IMG-2847-A · sifone" hint="primo piano" />
              <PhotoTile label="IMG-2847-B · ristagno" hint="mobile sottostante" />
              <button style={{
                aspectRatio: '1', borderRadius: 10, border: `1px dashed ${C.border}`,
                background: 'transparent', display: 'grid', placeItems: 'center',
                color: C.textSec, fontSize: 12, cursor: 'pointer', gap: 4, flexDirection: 'column',
              }}>
                <Camera size={20} />
                Aggiungi foto
              </button>
            </div>
          </div>

          {/* Timeline */}
          <div>
            <div style={{ ...overline, marginBottom: 16 }}>Timeline</div>
            <div style={{ position: 'relative', paddingLeft: 28 }}>
              <div style={{ position: 'absolute', left: 11, top: 8, bottom: 8, width: 1.5, background: C.border }} />
              <TimelineItem accent={C.cyan} icon={Wrench} time="09:42 · 14 sec fa"
                title="Tecnico assegnato" subtitle="Luca M. ha preso in carico il ticket" />
              <TimelineItem accent={C.gold} icon={MessageSquare} time="09:41"
                title="Capo manutentore notificato" subtitle="Auto-routing per priorità URGENTE" />
              <TimelineItem accent={C.gold} icon={Camera} time="09:40"
                title="Foto aggiunte" subtitle="Marco R. ha caricato 2 immagini (sifone, ristagno)" />
              <TimelineItem accent={C.terra} icon={AlertTriangle} time="09:40"
                title="Ticket aperto · URGENTE" subtitle="Marco R. da Front Office Galleria" last />
            </div>
          </div>
        </div>

        {/* RIGHT: actions & info */}
        <div style={{ padding: '32px 28px', background: C.surf }}>
          <button style={{ ...primaryBtn, width: '100%', padding: '14px', fontSize: 14, justifyContent: 'center' }}>
            <PlayCircle size={16} /> Avvia intervento
          </button>
          <div style={{ display: 'flex', gap: 8, marginTop: 8 }}>
            <button style={{ ...secondaryBtn, flex: 1, justifyContent: 'center', padding: '11px' }}>
              <CheckCircle2 size={14} /> Risolto
            </button>
            <button style={{ ...secondaryBtn, flex: 1, justifyContent: 'center', padding: '11px',
                            color: C.terra, borderColor: `${C.terra}55` }}>
              Escalation
            </button>
          </div>

          <Divider />

          <SidebarBlock label="Tecnico assegnato">
            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
              <div style={{
                width: 36, height: 36, borderRadius: '50%',
                background: `linear-gradient(135deg, ${C.cyan}, ${C.emerald})`,
                display: 'grid', placeItems: 'center', fontWeight: 600, fontSize: 13, color: '#fff',
              }}>LM</div>
              <div>
                <div style={{ fontSize: 13.5, fontWeight: 600 }}>Luca Marini</div>
                <div style={{ fontSize: 11.5, color: C.textSec }}>Idraulico · Online · 2 ticket attivi</div>
              </div>
            </div>
            <button style={{ ...secondaryBtn, width: '100%', justifyContent: 'center',
                            padding: '8px', marginTop: 12, fontSize: 12 }}>
              Riassegna
            </button>
          </SidebarBlock>

          <Divider />

          <SidebarBlock label="Dettagli">
            <Row k="Hotel" v="Galleria · Milano" />
            <Row k="Camera/Area" v="208 · Bagno principale" />
            <Row k="Categoria" v="Idraulica" />
            <Row k="Stato ospite" v="In colazione" />
            <Row k="Stato camera" v="Occupata" />
            <Row k="Operatore" v="Marco R. (FO)" />
            <Row k="ID interno" v="TKT-2847" mono />
          </SidebarBlock>

          <Divider />

          <SidebarBlock label="Documenti correlati">
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              <DocRow name="Scheda ricambi sifone" />
              <DocRow name="Storico ticket Camera 208" />
              <DocRow name="Contratto idraulico fornitore" />
            </div>
          </SidebarBlock>
        </div>
      </div>
    </div>
  );
}

const Meta = ({ icon: Icon, text }) => (
  <span style={{ display: 'inline-flex', alignItems: 'center', gap: 5 }}>
    <Icon size={12} /> {text}
  </span>
);

const PhotoTile = ({ label, hint }) => (
  <div style={{
    aspectRatio: '1', borderRadius: 10, position: 'relative', overflow: 'hidden',
    background: `linear-gradient(135deg, ${C.surf}, ${C.surfLight})`,
    border: `1px solid ${C.border}`, cursor: 'pointer',
  }}>
    <div style={{
      position: 'absolute', inset: 0,
      background: `radial-gradient(circle at 30% 40%, ${C.cyan}22, transparent 50%),
                   radial-gradient(circle at 70% 70%, ${C.terra}22, transparent 50%)`,
    }} />
    <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0,
                  padding: '10px 12px', background: 'linear-gradient(transparent, rgba(0,0,0,0.8))' }}>
      <div style={{ fontSize: 11, fontWeight: 600 }}>{label}</div>
      <div style={{ fontSize: 10, color: C.textSec }}>{hint}</div>
    </div>
  </div>
);

const TimelineItem = ({ icon: Icon, accent, title, subtitle, time, last }) => (
  <div style={{ position: 'relative', paddingBottom: last ? 0 : 22 }}>
    <div style={{
      position: 'absolute', left: -28, top: 0, width: 24, height: 24, borderRadius: '50%',
      background: `${accent}22`, border: `1.5px solid ${accent}`,
      display: 'grid', placeItems: 'center',
    }}><Icon size={11} color={accent} /></div>
    <div style={{ fontSize: 13.5, fontWeight: 600, marginBottom: 2 }}>{title}</div>
    <div style={{ fontSize: 12, color: C.textSec }}>{subtitle}</div>
    <div style={{ fontSize: 11, color: C.textDim, marginTop: 3 }}>{time}</div>
  </div>
);

const Divider = () => <div style={{ height: 1, background: C.border, margin: '24px 0' }} />;
const SidebarBlock = ({ label, children }) => (
  <div>
    <div style={{ ...overline, marginBottom: 12 }}>{label}</div>
    {children}
  </div>
);
const Row = ({ k, v, mono }) => (
  <div style={{ display: 'flex', justifyContent: 'space-between', padding: '7px 0', fontSize: 12.5 }}>
    <span style={{ color: C.textSec }}>{k}</span>
    <span style={{ fontWeight: 500, fontFamily: mono ? 'monospace' : 'inherit' }}>{v}</span>
  </div>
);
const DocRow = ({ name }) => (
  <div style={{
    display: 'flex', alignItems: 'center', gap: 8, padding: '8px 10px',
    background: C.bg, borderRadius: 8, border: `1px solid ${C.border}`,
    fontSize: 12, cursor: 'pointer',
  }}>
    <FileText size={12} color={C.gold} />
    <span style={{ flex: 1 }}>{name}</span>
    <ChevronRight size={12} color={C.textSec} />
  </div>
);
